import { v4 } from "uuid";

export function computePlanLinesWithOdooInfo(productionPlan, odooSo) {
  const planLines = productionPlan.finalLines
    .reduce((res, i) => {
      const found = res.find(
        (x) =>
          x.product.id === i.product.id &&
          x.salesPrice === i.salesPrice &&
          x.discountPercentage === i.discountPercentage,
      );
      if (found)
        return res.map((x) =>
          x.id === found.id ? { ...x, qty: x.qty + i.finalQty } : x,
        );
      return [...res, { ...i, id: v4(), qty: i.finalQty }];
    }, [])
    .map((planLine) => {
      const odooLines = odooSo.order_line.filter(
        (odooLine) =>
          odooLine.product_id &&
          odooLine.product_id.id === planLine.product.odooId &&
          odooLine.price_unit === planLine.salesPrice &&
          odooLine.discount === planLine.discountPercentage &&
          odooLine.product_uom_qty > 0,
      );
      console.log("odooSo.order_line", odooSo.order_line);
      console.log("odooLines", odooLines);
      const odooTotalQty = odooLines.reduce(
        (sum, odooLine) => sum + odooLine.product_uom_qty,
        0,
      );
      const isSynced = odooTotalQty === planLine.qty;
      return { ...planLine, odooTotalQty, isSynced };
    });

  const planProductOdooIds = planLines.map((i) => i.product.odooId);

  const odooLinesWithNotFoundInPlanLines = odooSo.order_line.filter(
    (i) =>
      !i.product_id ||
      !planProductOdooIds.includes(i.product_id.id) ||
      !planLines.find(
        (planLine) =>
          planLine.product.odooId === i.product_id.id &&
          planLine.salesPrice === i.price_unit &&
          planLine.discountPercentage === i.discount,
      ),
  );

  return {
    planLines,
    odooLinesWithNotFoundInPlanLines,
    isSynced: planLines.every((line) => line.isSynced),
  };
}
